export enum SUBSCRIBE_BUTTON_STATUS {
    subscribe = 0,
    unsubscribe = 1
}

export enum SUBSCRIBE_STATUS {
    active = 0,
    disable = 1
}

export enum SUBSCRIBE_VISIBILITY_STATUS {
    visible = 0,
    hidden = 1
}

export interface SubscribeEvents {
    onCancelSubscribe?: (subscriberId: string, targetId: string, name?: string, targetType?: string) => void,
    onUnsubscribe?: (subscriberId: string, targetId: string, targetType?: string) => void,
    onEditSubscribe?: (subscriberId?: string, targetType?: string) => void,
    onShowHideSubscribe?: (id: string) => void,
    onStopSubscribe?: (id: string) => void,
    onUpdateSubVisibility?: ( 
        subscriberId: string, 
        targetId: string, 
        mode: SUBSCRIBE_VISIBILITY_STATUS,
        targetType?: string
    ) => void
}export enum SUBSCRIBE_BUTTON_STATUS {
    subscribe = 0,
    unsubscribe = 1
}

export enum SUBSCRIBE_STATUS {
    active = 0,
    disable = 1
}

export enum SUBSCRIBE_VISIBILITY_STATUS {
    visible = 0,
    hidden = 1
}

export interface SubscribeEvents {
    onCancelSubscribe?: (subscriberId: string, targetId: string, name?: string, targetType?: string) => void,
    onUnsubscribe?: (subscriberId: string, targetId: string, targetType?: string) => void,
    onEditSubscribe?: (subscriberId?: string, targetType?: string) => void,
    onShowHideSubscribe?: (id: string) => void,
    onStopSubscribe?: (id: string) => void,
    onUpdateSubVisibility?: ( 
        subscriberId: string, 
        targetId: string, 
        mode: SUBSCRIBE_VISIBILITY_STATUS,
        targetType?: string
    ) => void
}